export const graphPromoteInstallmentsConfiguration = {
  minimumPrice: 40,
  numberOfInstallments: 3,
}
